import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';

const CancelConfirmationStepMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride('primaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);

export default CancelConfirmationStepMetaOverrideSet;
